import React from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  FolderOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SceneBox from "components/SceneBox";

export default function DataHub() {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");

  
  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="DATA" subtitle="Final Files Folders" />
        <Box>
        </Box>
      </FlexBetween>

      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 1 */}
        <SceneBox
          value="Quotes"
          onClick={() => {
                window.open('https://drive.google.com/drive/folders/1i8UU22lE5OwSi-XB-mwIQDyuufYFcMUr?usp=sharing');
              }}
          icon={
            <FolderOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Checklists"
          onClick={() => {
                window.open('https://drive.google.com/drive/folders/1-JSaDMiBtR5LRYk2dB4G4HKGOPKZ1C-S?usp=sharing');
              }}
          icon={
            <FolderOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Materiels A Fournir"
          onClick={() => {
                window.open('https://drive.google.com/drive/folders/1LQtsvD-pig9eqKF_Nxl1QruG6H9Jsix4?usp=sharing');
              }}
          icon={
            <FolderOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Menus"
          onClick={() => {
                window.open('https://drive.google.com/drive/folders/1s5I3_i8rQprCyGdPFzQAT9ybJMYmVRsN?usp=sharing');
              }}
          icon={
            <FolderOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
    </Box>
  );
};